import colors from "../scss/colors.module.scss"

const {
  ppGreen,
  ppRose,
  uiWhite,
  uiLightGray,
  uiMedGray,
  uiTransparent,
  parcelStop1,
  parcelStop2,
  parcelStop3,
  parcelStop4,
  parcelStop5,
  parcelStop6,
  parcelStop7,
} = colors

export {
  ppGreen,
  ppRose,
  uiWhite,
  uiLightGray,
  uiMedGray,
  uiTransparent,
  parcelStop1,
  parcelStop2,
  parcelStop3,
  parcelStop4,
  parcelStop5,
  parcelStop6,
  parcelStop7,
}
